// apps/products/scheduler-cdn/src/setup-mounts.ts
import { createRoot, Root } from 'react-dom/client';
import { SchedulerCdnSelectors } from './constants';
import { styles } from './styles';

export const mountScheduler = () => {
  // Create the main container if it doesn't exist
  let container = document.getElementById(
    SchedulerCdnSelectors.ROOT.toString()
  );
  if (!container) {
    container = document.createElement('div');
    container.id = SchedulerCdnSelectors.ROOT.toString();
    container.classList.add(SchedulerCdnSelectors.ROOT.toString());
    document.body.appendChild(container);
  }

  return container;
};

export const mountPortal = () => {
  // Create the portal container if it doesn't exist
  let portalContainer = document.getElementById(
    SchedulerCdnSelectors.PORTAL.toString()
  );
  if (!portalContainer) {
    portalContainer = document.createElement('div');
    portalContainer.id = SchedulerCdnSelectors.PORTAL.toString();
    portalContainer.classList.add(SchedulerCdnSelectors.PORTAL.toString());
  }

  return portalContainer;
};

export const mountFontLinks = () => {
  const links = [
    {
      rel: 'preconnect',
      href: 'https://fonts.googleapis.com',
    },
    {
      rel: 'preconnect',
      href: 'https://fonts.gstatic.com',
      crossorigin: 'anonymous',
    },
    {
      rel: 'stylesheet',
      href: 'https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap',
    },
  ];

  links.forEach((link) => {
    const element = document.createElement('link');
    Object.entries(link).forEach(([key, value]) => {
      element.setAttribute(key, value);
    });
    document.head.appendChild(element);
  });
};

export const mountSchedulerShadow = (): {
  root: Root;
  schedulerContainer: HTMLElement;
  portalContainer: HTMLElement;
} => {
  // Get containers
  const schedulerContainer = mountScheduler();

  // Setup shadow DOM
  let shadow = schedulerContainer.shadowRoot;
  if (!shadow) {
    shadow = schedulerContainer.attachShadow({ mode: 'open' });
  } else {
    shadow.innerHTML = ''; // Clean up existing content
  }

  // Inject styles into shadow DOM
  const style = document.createElement('style');
  style.textContent = styles;
  shadow.appendChild(style);

  // Create a root div for React mounting
  const portalContainer = mountPortal();
  shadow.appendChild(portalContainer);

  // Create React root
  const root = createRoot(portalContainer);

  return { root, schedulerContainer, portalContainer };
};
